// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flgaJvNfJliCIE {
  margin-top: 40px;
}
.djFTFVpF8ALdfA {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: F8CQoBCbi3zAfh;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 12px;
  margin-top: 16px;
  margin-bottom: 12px;
}
@keyframes F8CQoBCbi3zAfh {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .djFTFVpF8ALdfA {
    animation: none;
  }
}
.hql9FOtrXcVGil {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: F8CQoBCbi3zAfh;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 20px;
  margin-top: 12px;
  margin-bottom: 12px;
}
@keyframes F8CQoBCbi3zAfh {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hql9FOtrXcVGil {
    animation: none;
  }
}
.TPBesxTA0JP_r1 {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: F8CQoBCbi3zAfh;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 100px;
  margin-top: 4px;
  margin-bottom: 12px;
}
@keyframes F8CQoBCbi3zAfh {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .TPBesxTA0JP_r1 {
    animation: none;
  }
}
.bcbdpAdFgKZib3 {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: F8CQoBCbi3zAfh;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 20px;
  margin-top: 12px;
  margin-bottom: 12px;
}
@keyframes F8CQoBCbi3zAfh {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .bcbdpAdFgKZib3 {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonWrapper": `flgaJvNfJliCIE`,
	"skeletonSectionTitle": `djFTFVpF8ALdfA`,
	"shimmer": `F8CQoBCbi3zAfh`,
	"skeletonPopoverOption": `hql9FOtrXcVGil`,
	"skeletonColorSection": `TPBesxTA0JP_r1`,
	"skeletonButlerOption": `bcbdpAdFgKZib3`
};
export default ___CSS_LOADER_EXPORT___;
